import { createElement } from 'react';
import PropTypes from 'prop-types';
import styles from './list.module.less';

const List = ({ tag = 'ul', children = null, className = '' }) =>
    createElement(tag, { className: [styles.list, className].join(' ') }, children);

List.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    tag: PropTypes.oneOf(['ul', 'ol']),
};

export default List;
